<template>
  <div class="register">
    <div class="container" v-if="step === 3">
      <div class="header">
        <img class="suc-img" src="@/assets/suc.png" alt="suc">
        <div class="suc-title">密码设置成功！3秒后跳转到登录页</div>
        <div class="sub-info">
          在电脑登录精诊三维影像重建官网<br> https://crm.truesight.com.cn<br> 即可创建订单！
        </div>
      </div>
      <div class="footer">
        <img src="@/assets/logo.png" alt="" class="logo">
        精诊医疗科技有限公司
      </div>
    </div>
    <div class="container" v-if="step === 1">
      <div class="header">
        <div class="header-content">
          <img class="invite" src="@/assets/invite.png" alt="" srcset="">
          <div class="title-wrap">
            <div class="title">
              精诊科技
            </div>
            <div class="info">
              邀请您登录三维影像重建账号
              <div class="info-bg"></div>
            </div>
          </div>
        </div>
        <div class="phone-warp">
          <img class="icon" src="@/assets/phone.png" alt="">
          <div class="zh-code">
            +86
          </div>
          <img class="line" src="@/assets/line.png" alt="">
          <input type="text" class="phone-input" placeholder="请输入手机号" v-model="mobile">
        </div>
        <div class="code-wrap">
          <input type="text" class="input-code" placeholder="请输入验证码" v-model="sms">
          <el-button class="send-code" :class="{'disabled': (count !== 60 || mobile.length !== 11)}" @click="handleSend" :disabled="(count !== 60 || mobile.length !== 11)">
            {{count !== 60 ? count + 's后重新发送' :  '获取验证码'}}
          </el-button>
        </div>
        <div class="reg-btn" :class="{ 'btn-disable': (mobile.length !== 11 || sms.length !== 6) }" @click="handleSetPass">
          下一步
        </div>
      </div>
      <div class="footer">
        <img src="@/assets/logo.png" alt="" class="logo">
        精诊医疗科技有限公司
      </div>
    </div>
    <div class="container" v-if="step === 2">
      <div class="header set-pass">
        <div class="phone-warp" style="margin-bottom: 4px">
          <img class="icon" src="@/assets/lock.png" alt />
          <input type="password" class="phone-input" placeholder="请设置登陆密码" v-model="password" />
          <img class="icon" src="@/assets/del.png" v-if="password" @click="password = ''" />
        </div>
        <div class="line-info" v-if="passValid">6</div>
        <div class="pass-info" v-else>6-16个字符组成，其中包含大写字母，小写字母，数字</div>
        <div class="code-wrap" style="margin-bottom: 4px">
          <img class="icon" src="@/assets/relock.png" alt />
          <input type="password" class="phone-input" placeholder="再次输入密码" v-model="password_confirm" />
          <img class="icon" src="@/assets/del.png" v-if="password_confirm" @click="password_confirm= ''" />
        </div>
        <div class="line-info" v-if="rePassValid">6</div>
        <div class="pass-info" v-else>两次输入密码不一致!</div>
        <div class="reg-btn" :class="{'btn-disable': !isValid}" @click="handleSubmit">确认</div>
      </div>
      <div class="footer">
        <img src="@/assets/logo.png" alt="" class="logo" />
        精诊医疗科技有限公司
      </div>
    </div>
    <div class="toast" v-if="showToast">
      验证码已发送
    </div>
  </div>
</template>
<script>
import { login } from '@/api';

export default {
  name: 'Register',
  data() {
    return {
      showToast: false,
      count: 60,
      mobile: '',
      timer: null,
      step: 1,
      password: '',
      password_confirm: '',
      sms: ''
    };
  },
  computed: {
    passValid() {
      if (!this.password || /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,16}$/.test(this.password)) {
        return true;
      }
      return false;
    },
    rePassValid() {
      if (!this.password_confirm || this.password === this.password_confirm) {
        return true;
      }
      return false;
    },
    isValid() {
      if (this.password === this.password_confirm && /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,16}$/.test(this.password)) {
        return true;
      }
      return false;
    }
  },
  methods: {
    handleSetPass() {
      if (this.mobile.length === 11 || this.sms.length === 6) {
        this.step = 2;
      }
    },
    handleSend() {
      if (!this.mobile) {
        this.$message.error('请先输入手机号！');
        return;
      }
      if (String(this.mobile).length !== 11) {
        this.$message.error('请输入正确的手机号码！');
        return;
      }
      login.smsSendNoVerify({
        mobile: this.mobile,
      })
        .then(res => {
          if (res.code === 10000) {
            this.count = this.count - 1;
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000);
            this.timer = setInterval(() => {
              if (this.count <= 1) {
                this.count = 60;
                clearInterval(this.timer);
              } else {
                this.count = this.count - 1;
              }
            }, 1000);
            return;
          }
          this.count = 60;
          this.$message.error(res.msg);
        });
    },
    handleSubmit() {
      if (!this.isValid) return;
      login.userResetPassword({
        repeatPassword: this.password_confirm,
        mobile: this.mobile,
        sms: this.sms,
        password: this.password
      })
        .then(res => {
          if (res.code === 10000) {
            this.step = 3;
            setTimeout(() => {
              this.$router.push({
                path: '/login'
              });
            }, 3000);
            return;
          }
          this.$message.error(res.msg);
        });
    }
  },
};
</script>
<style scoped>
.register {
  height: 100vh;
  background-color: #374259;
  color: #7093cc;
  font-size: 16px;
}
::-webkit-input-placeholder {
  font-size: 16px;
  font-weight: 300;
  color:rgba(255,255,255,.3);
}

::input-placeholder {
  font-size: 16px;
  font-weight: 300;
  color:rgba(255,255,255,.3);
}

.app {
  height: 100vh;
  background-color: #374259;
  color: #7093cc;
  font-size: 16px;
}

input {
  background-color: #374259;
  border: 0;
  color: #D4D6DA;
}

.container {
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}

.header {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: 0 16px;
}

.set-pass {
  margin-top: 16px;
}

.suc-img {
  height: 64px;
  width: 64px;
  margin-top: 44px;
  margin-bottom: 20px;
}

.suc-title {
  color: #bbd8ff;
  font-size: 24px;
}

.footer {
  color: #7093cc;
  font-size: 16px;
  position: fixed;
  bottom: 17px;
  display: flex;
  align-items: center;
}

.footer > img {
  display: flex;
  align-items: center;
  justify-content: center;
}

.invite {
  height: 52px;
  width: 52px;
  margin-right: 9px;
}

.title {
  font-weight: 400;
  font-size: 22px;
  color: #bbd8ff;
  text-shadow: 0px 0px 30px rgba(0, 0, 0, 0.06);
}

.disabled {
  opacity: .3;
}

.info {
  font-size: 14px;
  font-weight: 300;
  color: #bbd8ff;
  text-shadow: 0px 0px 30px rgba(0, 0, 0, 0.06);
  position: relative;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, .1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
}

.info-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.1;
}

.header-content {
  margin-bottom: 17px;
  display: flex;
  margin-top: 18px;
  align-items: center;
  width: 100%;
}

.phone-warp {
  width: 343px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid rgba(58, 70, 90, 1);
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.code-wrap {
  width: 343px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid rgba(58, 70, 90, 1);
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.line-info {
  opacity: 0;
  margin-bottom: 8px;
}

.reg-btn {
  width: 343px;
  height: 48px;
  background: linear-gradient(
    135deg,
    rgba(94, 174, 243, 1) 0%,
    rgba(70, 112, 180, 1) 54%,
    rgba(64, 93, 167, 1) 100%
  );
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: rgba(198, 226, 255, 1);
}

.btn-disable {
  background: linear-gradient(
    135deg,
    rgba(94, 174, 243, 1) 0%,
    rgba(70, 112, 180, 1) 54%,
    rgba(64, 93, 167, 1) 100%
  );
  opacity: 0.2;
}

.zh-code {
  margin-left: -12px;
}

.icon {
  height: 56px;
  width: 56px;
}

.line {
  width: 1px;
  height: 23px;
  margin-left: 12px;
}

.phone-input {
  height: 100%;
  font-size: 22px;
  font-weight: 400;
  padding-left: 12px;
}

.input-code {
  height: 100%;
  width: 100%;
  font-size: 22px;
  font-weight: 400;
  padding-left: 12px;
}

.send-code {
  background: rgba(71, 78, 96, 1);
  border-radius: 4px;
  color: #D4D6DA;
  border: 1px solid rgba(255, 255, 255, 1);
  font-size: 12px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toast {
  max-width: 182px;
  height: 46px;
  background: rgba(234, 240, 255, 0.11);
  border-radius: 4px;
  position: absolute;
  top: 129px;
  left: 0;
  right: 0;
  margin: auto;
  font-size: 16px;
  font-weight: 300;
  color: rgba(239, 247, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.pass-info {
  font-size: 12px;
  font-weight: 300;
  color: rgba(255, 255, 255, .5);
  align-self: center;
  margin-bottom: 8px;
}
.sub-info {
  font-size:12px;
  font-family:PingFangSC-Light,PingFang SC;
  font-weight:300;
  color: #A5B5CF;
  width: 180px;
  text-align: center;
  line-height: 17px;
  margin-top: 10px;
}
.logo {
  height: 24px;
  width: 24px;
}
</style>



// WEBPACK FOOTER //
// src/view/Register/index.vue